import { render } from "./OrganizationChart.vue?vue&type=template&id=d5180240"
import script from "./OrganizationChart.vue?vue&type=script&lang=js"
export * from "./OrganizationChart.vue?vue&type=script&lang=js"

import "./OrganizationChart.vue?vue&type=style&index=0&id=d5180240&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__